import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Button } from '@material-ui/core';
import useTable from '../../useTable';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { parseDate } from '../../Models/CommonFunc';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { useHistory } from 'react-router-dom';
import "jspdf-autotable";
import { getAllExcelPdfInvoiceDocument, getDownloadUrlFromFullPath } from '../../../Backend/firebase/collection-wholesaler';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'chemistUid', label: 'Chemist ID', disableSorting: true },
    { id: 'ChemistInfo', label: 'Chemist Info', disableSorting: false },
    { id: 'TotalAmount', label: 'Total Amount', disableSorting: false },
    { id: 'invoiceNo', label: 'Invoice No', disableSorting: false },
    { id: 'invoiceDate', label: 'Date', disableSorting: false },
    { id: '_id', label: 'Action', disableSorting: false },
]

function ChemistExcelPdfInvoiceHistory() {
    const classes = useStyles();
    const history = useHistory()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();

    const [records, setRecords] = useState([]);
    const [displayRecords, setDisplayRecords] = useState([]);
    const [SalectedDate, setSalectedDate] = useState(parseDate(new Date()));
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination } = useTable(records, headCells);

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
            history.push("/activity/Login");
        }
    }, [])

    const getLast7DaysDateRange = () => {
        const today = new Date();
        const last7Days = new Date();
        last7Days.setDate(today.getDate() - 7);

        return {
            start: last7Days,
            end: today,
        };
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const { start, end } = getLast7DaysDateRange();
                const getExcelPdfInvoice = await getAllExcelPdfInvoiceDocument();
                const todaysExcelPdfInvoice = getExcelPdfInvoice.filter(x => {
                    const supplyDate = x.invoiceDate.toDate();
                    return supplyDate >= start && supplyDate <= end;
                });
                setRecords(todaysExcelPdfInvoice);
                setDisplayRecords(todaysExcelPdfInvoice);
                setIsLoading(false);
            } catch (error) {
                console.log("Error Occur in Get Order", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    useEffect(() => {
        const filteredRecords = records.filter(record => {
            const dateMatch = SalectedDate
                ? parseDate(record.invoiceDateparseDate).includes(SalectedDate)
                : true;

            return dateMatch;
        });

        setDisplayRecords(filteredRecords);
    }, [SalectedDate]);

    const viewExcelPdfInvoice = async (path, name) => {
        var url = await getDownloadUrlFromFullPath(path);
        window.open(url, "_blank", 'noopener,noreferrer')
        // router.push(url)
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Order | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-9 inline-style">
                                <h5>Invoice List</h5>
                            </div>
                            <div className="col-md-3">
                                <div className="allProductsTable__searchBox e-border-outline">
                                    <DatePickerComponent
                                        id="SalectedDate"
                                        name="SalectedDate"
                                        value={SalectedDate}
                                        cssclassName="e-outline"
                                        onChange={(e) => setSalectedDate(parseDate(e.target.value))}
                                        format="dd/MM/yyyy"
                                        cleared={() => {
                                            setTimeout(() => {
                                                setSalectedDate(parseDate(new Date()))
                                            }, 500)
                                        }}
                                    />
                                </div>
                            </div>
                            {displayRecords.length > 0 ? <div className="row col-md-12 supply-order-table">
                                <TblContainer>
                                    <TblHead />
                                    <TableBody>
                                        {
                                            displayRecords.map(item => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item?.chemistUid ? item.chemistUid : "NA"}</TableCell>
                                                    <TableCell>{item?.ChemistInfo ? item.ChemistInfo : "NA"}</TableCell>
                                                    <TableCell>{item?.TotalAmount ? `Rs.${item.TotalAmount}` : "NA"}</TableCell>
                                                    <TableCell>{item?.invoiceNo ? item.invoiceNo : "NA"}</TableCell>
                                                    <TableCell>
                                                        {typeof item?.invoiceDate == "string" ? item?.invoiceDate : parseDate(item?.invoiceDateparseDate)}
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className="mt-4">
                                                            <Button
                                                                variant="contained"
                                                                color="primary" className="navbar__btnLogin"
                                                                onClick={() => item?.invoiceDocumentPath ? viewExcelPdfInvoice(item.invoiceDocumentPath) : {}}>
                                                                {item?.invoiceDocumentPath ? 'View Invoice' : 'Unknown'}
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </TblContainer>
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Order Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
        </>
    )
}

export default ChemistExcelPdfInvoiceHistory
